import axios from 'axios'

const navixy = axios.create({
  baseURL: 'https://api.navixy.com/v2',
  headers: { 'Content-Type': 'application/json' },
})

navixy.interceptors.response.use(
  res => res,
  err => {
    console.error('API Error:', err.response?.data || err.message)
    return Promise.reject(err)
  }
)

export const userApi = {
  get_info: (sessionKey) =>
    navixy.post('/user/get_info', { hash: sessionKey }).then(r => r.data),
}

export default navixy
